import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

interface Action {
    moduleName?: string;
    [key: string]: unknown;
}

@Injectable({
    providedIn: 'root'
})
export class MixpanelService {
    /**
     * Initialize mixpanel.
     *
     * @param {string} userToken
     * @memberof MixpanelService
     */
    init(userToken?: string, user?: any): void {
        // if (environment.environmentName == 'Prod') {
        //     // mixpanel.init('10d735a972c9fd89362e60c000ef03c9');
        //     if (userToken) {
        //         mixpanel.identify(userToken);
        //         mixpanel.people.set({
        //             $name: user.attributes.full_name,
        //             $email: user.attributes.email || user.attributes.username,
        //             $tenant_name: user.attributes.tenant.company_name
        //         });
        //     }
        // }
    }

    /**
     * Push new action to mixpanel.
     *
     * @param {string} id Name of the action to track.
     * @param {*} [action={}] Actions object with custom properties.
     * @memberof MixpanelService
     */
    track(id: string, action: Action = { moduleName: '' }): void {
        // if (environment.environmentName == 'Prod') {
        //     mixpanel.track(id, action);
        // }
    }

    /**
     * Reset Mixpanel
     */
    logout() {
        if (environment.environmentName != 'Prod') {
            return;
        }

        // reset() on logout is the only live call into mixpanel-browser — init()
        // and track() above are commented out — and the package is 785 kB. A static
        // import kept all of it in the initial bundle for one call that most
        // sessions never make, so it is fetched on demand instead.
        void import('mixpanel-browser').then(({ default: mixpanel }) =>
            mixpanel.reset()
        );
    }
}
